export default () => {
  const $sliderArticles = $('.slider-articles');

  if ($sliderArticles.length === 0) {
    return;
  }

  const sliderOptions = {
    3: {
      992: 2,
      767: 2,
    },
    4: {
      992: 3,
      767: 2,
    },
  };

  for (let i = 0; i < $sliderArticles.length; i += 1) {
    const $slider = $($sliderArticles[i]);
    const slidesToShow = $slider.attr('data-slides-to-show');

    $slider.slick({
      slidesToShow,
      slidesToScroll: 1,
      appendArrows: $slider.closest('.slider-theme').find('.slider-theme__arrows'),
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: sliderOptions[slidesToShow]['992'],
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: sliderOptions[slidesToShow]['767'],
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }
};
